module.exports = __webpack_public_path__ + "static/media/chia-work-2.e73769d9.jpg";